var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import ReactModal from 'react-modal';
import { borderRadius, elevation, color, layer, divider } from '../../constants';
import { DisplaySmall } from '../../typography';
import { RemoveSmall } from '../../icons';
import { StyledFrame, FrameHeader, FrameContent, FrameFooter } from '../Frame';
import { IconButton } from '../IconButton';
import { Thirds, Left, Center, Right } from '../../layout';
var GradientBorder = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-image: ", ";\n  border-image-slice: 1;\n"], ["\n  border-image: ", ";\n  border-image-slice: 1;\n"])), divider.gradient.horizontal);
var ModalTitle = styled(DisplaySmall)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var transformStyle = {
    overlay: {
        transform: 'none'
    },
    content: {
        transform: 'none'
    }
};
var ModalWrapper = function (_a) {
    var className = _a.className, children = _a.children, title = _a.title, onRequestClose = _a.onRequestClose, props = __rest(_a, ["className", "children", "title", "onRequestClose"]);
    var Title = typeof title === 'string' && title !== undefined ? (React.createElement(ModalTitle, null, title)) : (title);
    return (React.createElement(ReactModal, __assign({ style: transformStyle, ariaHideApp: false, className: "Modal-content", overlayClassName: className, onRequestClose: onRequestClose }, props),
        React.createElement(StyledFrame, { className: "Modal-Frame" },
            title !== undefined ? (React.createElement(ModalHeader, null,
                React.createElement(Thirds, null,
                    React.createElement(Left, null,
                        React.createElement(IconButton, { icon: React.createElement(RemoveSmall, null), onClick: onRequestClose })),
                    React.createElement(Center, null, Title),
                    React.createElement(Right, null)))) : null,
            children)));
};
ModalWrapper.defaultProps = {
    title: ''
};
/**
 * Wrapper of the Modal, using `react-modal`
 * Modal component has two required props
 *
 * * `title: string`
 * * `onRequestClose: function`
 *
 * Modal component can also have following components as sub components.
 *
 * * `ModalContent`
 * * `ModalFooter`
 *
 * The Modal Header will be rendered automatically once `title` and `onRequestClose` are provided.
 * It's recommended to import `ModalContent` for wrapping actual content and `ModalFooter` for
 * wrapping action buttons. The idea of using `ModalContent` and `ModalFooter` will be similar to the
 * usecase of `FrameContent` and `FrameFooter`. In fact, `ModalContent` and `ModalFooter` inherits
 * code from `FrameContent` and `FrameFooter` respectively.
 */
export var Modal = styled(ModalWrapper)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  z-index: ", ";\n\n  .Modal-content:focus {\n    outline: 0;\n  }\n\n  .Modal-Frame {\n    min-width: 480px;\n    max-width: 800px;\n    min-height: 300px;\n    max-height: 800px;\n    border: 0;\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  z-index: ", ";\n\n  .Modal-content:focus {\n    outline: 0;\n  }\n\n  .Modal-Frame {\n    min-width: 480px;\n    max-width: 800px;\n    min-height: 300px;\n    max-height: 800px;\n    border: 0;\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"
    /**
     * Alias of FrameHeader that to be used inside Modal, this allows developers
     * to construct a different header style with extra elements
     */
])), color.theme.overlay.dark, layer.modal, color.pureWhite, borderRadius.large, elevation.modal);
/**
 * Alias of FrameHeader that to be used inside Modal, this allows developers
 * to construct a different header style with extra elements
 */
export var ModalHeader = styled(FrameHeader)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  border: 0;\n  border-bottom: 1px solid;\n  ", "\n"], ["\n  position: relative;\n  border: 0;\n  border-bottom: 1px solid;\n  ", "\n"
    /**
     * Alias of FrameContent that to be used inside Modal, this is where the children live
     */
])), GradientBorder);
/**
 * Alias of FrameContent that to be used inside Modal, this is where the children live
 */
export var ModalContent = styled(FrameContent)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  overflow-y: auto;\n"], ["\n  overflow-y: auto;\n"
    /**
     * Using FrameFooter to implement ModalFooter, footer should contain Modal actions
     * ModalFooter assumes that it will only contain buttons, so the children will
     * be aligned to the right hand side using flexbox.
     */
])));
/**
 * Using FrameFooter to implement ModalFooter, footer should contain Modal actions
 * ModalFooter assumes that it will only contain buttons, so the children will
 * be aligned to the right hand side using flexbox.
 */
export var ModalFooter = styled(FrameFooter)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  border-top: 1px solid;\n  ", "\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  border-top: 1px solid;\n  ", "\n"])), GradientBorder);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map